import entity from './entity';
import { get } from '../../../../utils/state';

const {
  getByIdFromState,
  getByIdsFromState,
} = entity.getSelectors();

const getIsLoadingFromState = state => get(state, 'entities.subOrganizations.isLoading');
export const getSubOrganizations = state => get(state, 'entities.subOrganizations.data', {});
export const getSubOrganizationsPagination = state => get(state, 'entities.subOrganizations.pagination', {});
export const getSortOptions = state => get(state, 'entities.subOrganizations.sortOptions', {});
export const getSearchQuery = state => get(state, 'entities.subOrganizations.searchQuery', '');
export const getNewOrganizationId = state => get(state, 'entities.subOrganizations.newOrgId', null);
export const getNewSubOrgId = state => get(state, 'entities.subOrganizations.newSubOrgId', null);

export const getProfilesByOrgIsLoading = state => get(state, 'entities.subOrganizations.profiles.isLoading');
export const getProfilesByOrgData = state => get(state, 'entities.subOrganizations.profiles.data', {});
export const getProfilesByOrgPagination = state => get(state, 'entities.subOrganizations.profiles.pagination', {});

const state = {
  getIsLoading: getIsLoadingFromState,
  getNewOrganizationId,
  getProfilesByOrgIsLoading,
  getProfilesByOrgData,
  getProfilesByOrgPagination,
  getSearchQuery,
  getSortOptions,
  getSubOrganizations,
  getSubOrganizationsPagination,
  getSubOrgById: getByIdFromState,
  getSubOrgsByIds: getByIdsFromState,
  getNewSubOrgId,
};

export const {
  getSubOrgsByIds,
  getSubOrgById,
  getIsLoading,
} = state;

export default state;
